import { Component, OnInit } from '@angular/core';
import { EaccessAuthService } from '../../auth/eaccess-auth.service';
import { ROLE_AUDIT_TRAIL_USER_ACTIONS_READ } from '../../shared/constants';

@Component({
  selector: 'eaa-can-view-audit-trail-user-actions',
  template: `
    @if (canView) {
      <ng-content></ng-content>
    }
  `
})
export class CanViewAuditTrailUserActionsComponent implements OnInit {
  public canView: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  public ngOnInit(): void {
    this.authService.hasRole$(ROLE_AUDIT_TRAIL_USER_ACTIONS_READ).subscribe((hasRole) => (this.canView = hasRole));
  }
}
